import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { WHITE, BLACK, PURPLE } = colors;
import { Bogle_Regular } from 'constants/constant';

const dashboardStyles = makeStyles(() => ({
	feedbackBtn: {
		display: 'flex',
		alignItems: 'center',
		position: 'absolute',
		top: '40%',
		right: -41,
		background: WHITE,
		transform: 'rotate(270deg)',
		border: `1px solid ${PURPLE}`,
		height: 30,
		borderRadius: 1
	},
	feedbackIcon: {
		transform: 'rotate(90deg)',
		padding: '4px 4px 0px 4px'
	},
	feedbackTxt: {
		fontSize: 16,
		color: BLACK,
		fontFamily: Bogle_Regular,
		'&:hover': {
			background: 'transparent'
		}
	}
}));

export default dashboardStyles;
